import React, { Component } from 'react';
import logo from "../../images/logo.png";

//Footer
import agsmedico from "../../footer-citas/ags-medico-large.png";
import website from "../../footer-citas/website.png";

class FormAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: '',
      telefono: '',
      descripcion: '',
      fecha: '',
      hora: '',
      errorHora: '',
      errorFecha: '',
    };
  }

  // ---------------------
  // Manejo de eventos
  // ---------------------
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errorHora: '',
      errorFecha: ''
    });
  };

  validateHora = () => {
    const { hora, fecha } = this.state;
    if (!hora || !fecha) return;
  
    const chosenDateTime = new Date(`${fecha}T${hora}:00`);
    const now = new Date();
    const minAllowed = new Date(now.getTime() + 15 * 60000); // +15 minutos
  
    const hourChosen = parseInt(hora.split(":")[0], 10);
    const minuteChosen = parseInt(hora.split(":")[1], 10);
  
    if (hourChosen < 9 || (hourChosen >= 21 && minuteChosen > 0) || hourChosen >= 22) {
      this.setState({ errorHora: 'La hora debe estar entre 09:00 y 21:00' });
      setTimeout(() => this.setState({ hora: '', errorHora: '' }), 3000);
      return;
    }
  
    if (chosenDateTime < minAllowed) {
      this.setState({ errorHora: 'Debes seleccionar al menos 15 minutos posteriores a la hora actual' });
      setTimeout(() => this.setState({ hora: '', errorHora: '' }), 3000);
      return;
    }
  
    this.setState({ errorHora: '' });
  };
  

  validateFecha = () => {
    const { fecha } = this.state;
    if (!fecha) return;
  
    const chosen = new Date(fecha + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    if (chosen < today) {
      this.setState({ errorFecha: "No se puede agendar una cita para una fecha en el pasado" });
      setTimeout(() => this.setState({ fecha: '', errorFecha: '' }), 3000);
      return;
    }
  
    const diffDays = (chosen - today) / (1000 * 60 * 60 * 24);
    if (diffDays > 45) {
      this.setState({ errorFecha: "No es posible agendar una cita 45 días después del día de hoy" });
      setTimeout(() => this.setState({ fecha: '', errorFecha: '' }), 3000);
      return;
    }
  
    if (chosen.getFullYear() !== today.getFullYear()) {
      this.setState({ errorFecha: "Solo se permite agendar citas en el año actual" });
      setTimeout(() => this.setState({ fecha: '', errorFecha: '' }), 3000);
      return;
    }
  
    this.setState({ errorFecha: '' });
  };
  

  convertTimeTo12Hour = (timeStr) => {
    // "HH:MM" => "h:MM A.M./P.M."
    const [hour, minute] = timeStr.split(':');
    let hr = parseInt(hour, 10);
    const ampm = hr >= 12 ? 'P.M.' : 'A.M.';
    hr = hr % 12;
    if (hr === 0) hr = 12;
    return `${hr}:${minute} ${ampm}`;
  };

  // ---------------------
  // Envío a WhatsApp
  // ---------------------
  handleSubmit = (e) => {
    e.preventDefault();
    const { nombre, telefono, descripcion, fecha, hora, errorHora, errorFecha } = this.state;
    if (errorHora || errorFecha) return;
  
    const fechaArray = fecha.split('-');
    const formattedDate = (fechaArray.length === 3)
      ? `${fechaArray[2]}/${fechaArray[1]}/${fechaArray[0]}`
      : fecha;
  
    const convertedTime = this.convertTimeTo12Hour(hora);
  
    const isMobile = window.innerWidth < 768;
  
    let mensaje;
    if (isMobile) {
      mensaje =
        `📣 Nueva cita para Paciente: ${nombre}📣\n` +
        `📱Teléfono: ${telefono}\n` +
        `🩻Padecimiento: ${descripcion}\n` +
        `📅 Fecha y Hora de Cita: ${formattedDate} ${convertedTime}\n` +
        `_*Cita realizada desde dispositivo mobile*_`;
    } else {
      mensaje =
        `Nueva cita para Paciente: ${nombre}\n` +
        `Telefono: ${telefono}\n` +
        `Padecimiento: ${descripcion}\n` +
        `Fecha y Hora de Cita: ${formattedDate} ${convertedTime}\n` +
        `_*Cita realizada desde Desktop*_`;
    }
  
    const numero = '4491647579';
    const url = `https://wa.me/${numero}?text=${encodeURI(mensaje)}`;
    window.open(url, '_blank');
  
    // Limpiar los inputs después de 10 segundos
    setTimeout(() => {
      this.setState({
        nombre: '',
        telefono: '',
        descripcion: '',
        fecha: '',
        hora: '',
        errorHora: '',
        errorFecha: ''
      });
    }, 10000);
  };
  

  // ---------------------
  // Render
  // ---------------------
  render() {
    // Calcular min y max para la fecha
    const todayObj = new Date();
    todayObj.setHours(0, 0, 0, 0);
    const todayISO = todayObj.toISOString().split('T')[0];

    const maxDateObj = new Date(todayObj.getTime() + 45 * 24 * 60 * 60 * 1000);
    if (maxDateObj.getFullYear() !== todayObj.getFullYear()) {
      maxDateObj.setFullYear(todayObj.getFullYear(), 11, 31);
    }
    const maxDate = maxDateObj.toISOString().split('T')[0];

    const { errorHora, errorFecha } = this.state;

    // Estructura similar a form-login.jsx
    return (
      <>
      <div className="section-area account-wraper3">
        <div className="container">
          {/* Centra la columna en todas las pantallas */}
          <div className="row r">
            {/* 
              col-xl-5 col-lg-6 col-md-8 => 
              Móviles => ancho 100% (col-12 por defecto), 
              md => 8/12, lg => 6/12, xl => 5/12
              Asegura un formulario centrado y sin márgenes extra.
            */}
            <div className="col-xl-10 col-lg-8 col-md-10 col-sm-12 mx-auto">
              <div className="appointment-form-apt form-wraper">
                {/* Encabezado: Logo + Título */}
                <div className="row mb-4 align-items-center">
                  <div className="col-auto">
                    <img
                      src={logo}
                      alt="Logo"
                      style={{ height: '40px' }}
                    />
                  </div>
                  <div className="col">
                    <div className="d-flex justify-content-center align-items-center">
                      <h2 className="mb-0 text-center">Formulario de Citas</h2>
                    </div>
                  </div>
                </div>

                <form onSubmit={this.handleSubmit}>
                  {/* Nombre y Teléfono */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <input
                        type="text"
                        className="form-control"
                        name="nombre"
                        placeholder="Paciente"
                        value={this.state.nombre}
                        onChange={this.handleChange}
                        pattern="^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$"
                        title="Solo se permiten letras y espacios"
                        required
                        onInvalid={(e) => e.target.setCustomValidity('Es requerido introducir el nombre del paciente')}
                        onInput={(e) => e.target.setCustomValidity('')}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <input
                        type="tel"
                        className="form-control"
                        name="telefono"
                        placeholder="Teléfono"
                        value={this.state.telefono}
                        onChange={this.handleChange}
                        pattern="^[0-9\s]+$"
                        title="Solo se permiten números y espacios"
                        required
                        onInvalid={(e) => e.target.setCustomValidity('Es requerido introducir el teléfono del paciente')}
                        onInput={(e) => e.target.setCustomValidity('')}
                      />
                    </div>
                  </div>

                  {/* Descripción */}
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      name="descripcion"
                      placeholder="Describe brevemente el padecimiento"
                      value={this.state.descripcion}
                      onChange={this.handleChange}
                      required
                      style={{ minHeight: '120px' }}
                    />
                  </div>

                  {/* Fecha y Hora */}
                  <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Fecha de posible cita</label>
                    <input
                      type="date"
                      className="form-control"
                      name="fecha"
                      value={this.state.fecha}
                      onChange={this.handleChange}
                      onBlur={this.validateFecha}
                      min={todayISO}
                      max={maxDate}
                      required
                      onInvalid={(e) => e.target.setCustomValidity('Es requerido ingresar la fecha de la cita')}
                      onInput={(e) => e.target.setCustomValidity('')}
                    />
                    {errorFecha && (
                      <small className="text-danger">{errorFecha}</small>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Hora</label>
                    <input
                      type="time"
                      className="form-control"
                      name="hora"
                      value={this.state.hora}
                      onChange={this.handleChange}
                      onBlur={this.validateHora}
                      min="09:00"
                      max="21:00"
                      required
                      onInvalid={(e) => e.target.setCustomValidity('Es requerido seleccionar una hora para la cita')}
                      onInput={(e) => e.target.setCustomValidity('')}
                    />
                    {errorHora && (
                      <small className="text-danger">{errorHora}</small>
                    )}
                  </div>

                  </div>

                  {/* Botón */}
                  <div className="mb-3">
                    <button
                      type="submit"
                      className="btn btn-primary w-100 radius-xl"
                      disabled={!!errorHora || !!errorFecha}
                    >
                      Agendar Cita
                    </button>
                  </div>

                  {/* Footer con 4 íconos */}
                  <div className="row justify-content-center mt-4">
                    <div className="col-auto">
                      <a href="/" title="Inicio">
                        <img
                          src={website}
                          alt="Gastrocirugia Aguascalientes"
                          className="img-fluid"
                          style={{ maxWidth: '45px', maxHeight: '45px' }}
                        />
                      </a>
                    </div>
 
                    <div className="col-auto">
                      <a
                        href="https://agsmedico.com/cirugia-general/alvarezdelcastillo"
                        title="Aguascalientes Médico"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={agsmedico}
                          alt="Aguascalientes Médico"
                          className="img-fluid"
                          style={{ maxWidth: '265px', maxHeight: '45px' }}
                        />
                      </a>
                    </div>

                  </div>
                </form>
              </div> {/* appointment-form */}
            </div> {/* col-xl-5 col-lg-6 col-md-8 */}
          </div> {/* row justify-content-center */}
        </div> {/* container */}
      </div>

      </>
          );
  }
}

export default FormAppointment;
